function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import get from 'lodash/get';
import filter from 'lodash/filter';
import includes from 'lodash/includes';
import { FormattedMessage } from 'react-intl';
import map from 'lodash/map';
import Loupe from 'svg/loupe.svg';
import XIcon from 'svg/x.svg';
import Input from 'components/Form/Input';
import messages from 'modules/App/messages';
import styles from './MobileCountryCodeFormPartial.pcss';
import CountryRow from './CountryRow';
const FullScreenCountrySelector = ({ formValues, id, isSelectorOpen, optionsFrom, onChange, onCloseSelector })=>{
    const [countryFilter, setCountryFilter] = useState('');
    const currentValue = get(formValues, `values.${id}`);
    const filteredOptionsFrom = countryFilter ? filter(optionsFrom, ({ label })=>includes(label.toLowerCase(), countryFilter.toLowerCase())) : optionsFrom;
    const onChangeFilter = ({ value })=>{
        setCountryFilter(value);
    };
    const onSelectCountryRow = (value)=>{
        onChange({
            id,
            value
        });
        onCloseSelector();
    };
    const mapCountryRow = (value, label)=>{
        const isSelected = !!currentValue && value === currentValue;
        return /*#__PURE__*/ _jsx(CountryRow, {
            value: value,
            label: label,
            isSelected: isSelected,
            onSelectCountryRow: onSelectCountryRow
        }, value);
    };
    if (!isSelectorOpen) return null;
    return /*#__PURE__*/ _jsx(AnimatePresence, {
        children: /*#__PURE__*/ _jsx(motion.div, {
            initial: {
                height: 0
            },
            animate: {
                height: '100vh'
            },
            exit: {
                height: 0
            },
            transition: {
                ease: 'easeOut',
                duration: 0.15
            },
            className: styles.fullScreenCountrySelector,
            children: /*#__PURE__*/ _jsxs("div", {
                className: styles.fullScreenCountrySelector__inner,
                "data-testid": "fullscreen-country-selector",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        "aria-hidden": "true",
                        className: styles.closeSelector__wrapper,
                        children: /*#__PURE__*/ _jsx(XIcon, {
                            onClick: onCloseSelector,
                            className: styles.closeSelector__icon
                        })
                    }),
                    /*#__PURE__*/ _jsx("h1", {
                        className: `text--h2 mb-2 ${styles.fullScreenCountrySelector__headingText}`,
                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.selectCountry))
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: styles.info,
                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.selectCountry))
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles.search,
                        children: [
                            /*#__PURE__*/ _jsx(Input, {
                                id: "country-filter",
                                placeholder: messages.placeholders.selectCountry,
                                value: countryFilter,
                                onChange: onChangeFilter
                            }),
                            /*#__PURE__*/ _jsx(Loupe, {
                                className: styles.search__loupe
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("ul", {
                        className: styles.countryList,
                        children: map(filteredOptionsFrom, ({ value, label })=>mapCountryRow(value, label))
                    })
                ]
            })
        })
    });
};
export default FullScreenCountrySelector;
